
import React, { createContext, useContext, useState, useEffect } from 'react';

export type SectorType = 'agriculture' | 'household';

interface SectorContextType {
  sector: SectorType;
  setSector: (sector: SectorType) => void;
  toggleSector: () => void;
}

const SectorContext = createContext<SectorContextType | undefined>(undefined);

export const SectorProvider = ({ children }: { children: React.ReactNode }) => {
  const [sector, setSector] = useState<SectorType>(() => {
    // Try to get the sector from localStorage
    const savedSector = localStorage.getItem('aquagenius-sector');
    return (savedSector as SectorType) || 'household';
  });

  // Save sector to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('aquagenius-sector', sector);
  }, [sector]);

  // Toggle between sectors
  const toggleSector = () => {
    setSector(prev => prev === 'agriculture' ? 'household' : 'agriculture');
  };

  return (
    <SectorContext.Provider value={{ sector, setSector, toggleSector }}>
      {children}
    </SectorContext.Provider>
  );
};

export const useSector = () => {
  const context = useContext(SectorContext);
  if (context === undefined) {
    throw new Error('useSector must be used within a SectorProvider');
  }
  return context;
};
